import { Inject } from '@angular/core';
import '@angular/compiler';
import { PageAdminUserDetailComponent } from './page.admin.user.detail/page.admin.user.detail.component';
import { PortalSeasonTreeComponent } from './portal.season.tree/portal.season.tree.component';
import { PortalSeasonLoadingSeasonComponent } from './portal.season.loading.season/portal.season.loading.season.component';
import { PortalSeasonLoadingDefaultComponent } from './portal.season.loading.default/portal.season.loading.default.component';
import { ComponentNavAdminComponent } from './component.nav.admin/component.nav.admin.component';
import { PageKorslovoDashboardComponent } from './page.korslovo.dashboard/page.korslovo.dashboard.component';
import { PageKorslovoLearnComponent } from './page.korslovo.learn/page.korslovo.learn.component';
import { PageKorslovoCategoryItemComponent } from './page.korslovo.category.item/page.korslovo.category.item.component';
import { PageKorslovoCrosswordComponent } from './page.korslovo.crossword/page.korslovo.crossword.component';
import { PageKorslovoGameComponent } from './page.korslovo.game/page.korslovo.game.component';
import { PortalSeasonModalComponent } from './portal.season.modal/portal.season.modal.component';
import { LayoutAdminComponent } from './layout.admin/layout.admin.component';
import { PageKorslovoCategoryComponent } from './page.korslovo.category/page.korslovo.category.component';
import { PageKorslovoMypageComponent } from './page.korslovo.mypage/page.korslovo.mypage.component';
import { PortalSeasonPaginationComponent } from './portal.season.pagination/portal.season.pagination.component';
import { PageAdminLessonsComponent } from './page.admin.lessons/page.admin.lessons.component';
import { ComponentNavBottomComponent } from './component.nav.bottom/component.nav.bottom.component';
import { PageAccessComponent } from './page.access/page.access.component';
import { PortalPostListComponent } from './portal.post.list/portal.post.list.component';
import { PageKorslovoQuizComponent } from './page.korslovo.quiz/page.korslovo.quiz.component';
import { PageAdminUsersComponent } from './page.admin.users/page.admin.users.component';
import { PageAdminQualityComponent } from './page.admin.quality/page.admin.quality.component';
import { PortalPostDetailComponent } from './portal.post.detail/portal.post.detail.component';
import { LayoutEmptyComponent } from './layout.empty/layout.empty.component';
import { PortalSeasonFormDropdownComponent } from './portal.season.form.dropdown/portal.season.form.dropdown.component';
import { PageAdminWordsComponent } from './page.admin.words/page.admin.words.component';
import { PageKorslovoReviewComponent } from './page.korslovo.review/page.korslovo.review.component';
import { LayoutKorslovoComponent } from './layout.korslovo/layout.korslovo.component';
import { PageAdminDashboardComponent } from './page.admin.dashboard/page.admin.dashboard.component';
import { PageAdminCategoriesComponent } from './page.admin.categories/page.admin.categories.component';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule, COMPOSITION_BUFFER_MODE } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NuMonacoEditorModule } from '@ng-util/monaco-editor';
import { SortablejsModule } from "src/libs/portal/season/ngx-sortablejs";
import { KeyboardShortcutsModule } from 'ng-keyboard-shortcuts';
import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

@Pipe({ name: 'safe' })
export class SafePipe implements PipeTransform {
    constructor(@Inject( DomSanitizer) private domSanitizer: DomSanitizer) { }
    transform(url) {
        return this.domSanitizer.bypassSecurityTrustResourceUrl(url);
    }
}

// translate libs
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader'
import { HttpClient, HttpClientModule } from '@angular/common/http';

export function createTranslateLoader(http: HttpClient) {
    return new TranslateHttpLoader(http, './assets/lang/', '.json');
}

// initialize ng module
@NgModule({
    declarations: [
        SafePipe,
        AppComponent,
        PageAdminUserDetailComponent,
        PortalSeasonTreeComponent,
        PortalSeasonLoadingSeasonComponent,
        PortalSeasonLoadingDefaultComponent,
        ComponentNavAdminComponent,
        PageKorslovoDashboardComponent,
        PageKorslovoLearnComponent,
        PageKorslovoCategoryItemComponent,
        PageKorslovoCrosswordComponent,
        PageKorslovoGameComponent,
        PortalSeasonModalComponent,
        LayoutAdminComponent,
        PageKorslovoCategoryComponent,
        PageKorslovoMypageComponent,
        PortalSeasonPaginationComponent,
        PageAdminLessonsComponent,
        ComponentNavBottomComponent,
        PageAccessComponent,
        PortalPostListComponent,
        PageKorslovoQuizComponent,
        PageAdminUsersComponent,
        PageAdminQualityComponent,
        PortalPostDetailComponent,
        LayoutEmptyComponent,
        PortalSeasonFormDropdownComponent,
        PageAdminWordsComponent,
        PageKorslovoReviewComponent,
        LayoutKorslovoComponent,
        PageAdminDashboardComponent,
        PageAdminCategoriesComponent
    ],
    imports: [
        BrowserModule,
        AppRoutingModule,
        FormsModule,
        NgbModule,
        SortablejsModule,
        KeyboardShortcutsModule.forRoot(),
        NuMonacoEditorModule.forRoot({ baseUrl: `lib` }),
        HttpClientModule,
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: (createTranslateLoader),
                deps: [HttpClient]
            },
            defaultLanguage: 'en'
        }),
        
    ],
    providers: [
        {
            provide: COMPOSITION_BUFFER_MODE,
            useValue: false
        }
    ],
    bootstrap: [AppComponent]
})
export class AppModule { }